export default __webpack_public_path__ + "static/media/solem8slogo.5039900f.png";